import { render } from "./SideBarListings.vue?vue&type=template&id=4a95d599&scoped=true&ts=true"
import script from "./SideBarListings.vue?vue&type=script&lang=ts"
export * from "./SideBarListings.vue?vue&type=script&lang=ts"

import "./SideBarListings.vue?vue&type=style&index=0&id=4a95d599&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a95d599"]])

export default __exports__